import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/services/LoginService/login-service.service';
import { SessionService } from 'src/app/services/StoreService/SessionService/session.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Change_To_CNP_Channel_Action, Change_To_CP_Channel_Action, Change_To_WHATSAPP_Channel_Action } from 'src/app/services/Store/channel.actions';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private store: Store<{ channel: string }>
  ) {
    this.store.subscribe(state => {
      this.form.get("channel").setValue(state.channel);
    })
  }

  ngOnInit(): void { }

  url: string = this.router.url;

  user = this.sessionService.getUser();

  name: null | string = this.user.user.name;
  lastName: null | string = this.user.user.lastName;
  email: null | string = this.user.user.email;

  form = new FormGroup({
    channel: new FormControl("CNP", Validators.required)
  })

  roleAdmin = this.user.user.roles.includes("ADMIN");
  roleModerator = this.user.user.roles.includes("MODERATOR");
  roleUserReports = this.user.user.roles.includes("USER_REPORT");

  selectChannel(event) {

    if (event.value == "CNP") {
      const action = new Change_To_CNP_Channel_Action();
      this.store.dispatch(action);
    } else if (event.value == "CP") {
      const action = new Change_To_CP_Channel_Action();
      this.store.dispatch(action);
    } else if (event.value == "WHATSAPP") {
      const action = new Change_To_WHATSAPP_Channel_Action();
      this.store.dispatch(action);
    }

    if (
      this.url.includes("/pv/tracing") ||
      this.url.includes("/pv/checkout-template") ||
      this.url.includes("/pv/checkout-selected-template") ||
      this.url.includes("/pv/manage-template") ||
      this.url.includes("/pv/template-versions") ||
      this.url.includes("/pv/checkout-sale-kind") ||
      this.url.includes("/pv/sale-kind-information") ||
      this.url.includes("/pv/manage-sale-kind") ||
      this.url.includes("/pv/sale-kind-versions") ||
      this.url.includes("/pv/tracing")
    ) {
      this.router.navigate(["/pv/request-day"]);
    }
  }
}
